const LocalStoragePrefix = 'custom-report';

export const getLocalStorageKey = (reportId, reportSetId) =>
  `${LocalStoragePrefix}${reportId}${reportSetId ? `@${reportSetId}` : ''}`;

export const updateLocalStorage = ({ keyname, state }) => {
  window.localStorage.setItem(
    keyname,
    JSON.stringify({
      ...JSON.parse(window.localStorage.getItem(keyname)),
      ...state,
    })
  );
};
